import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Table, message, Row, Col, Tooltip, Tag } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { CHECK_STATUS, SYNC_STATUS } from '@/constants/resourcelist';
import apis from '../apis';
import sysApis from '../../system/apis';
import ContextResourceList from '@/pages/material-manage/context-resource-list';
import { connect } from 'react-redux';
import './index.less';
import Container from '@/components/container';
import { getQuery } from '@/common/utils';
import ChangeHover from './components/change-hover';
import CheckDetail from '../resource-manage/components/check-detail';
import BlockWrapper from '@/components/edit-activity-plan/block-wrapper';

import { useHistory } from 'react-router-dom';

function ResourceList({ resourceListInfo }) {
  const history = useHistory();
  const initalState = {
    page: 1,
    pageSize: 10,
    outActivityId: null,
    applyId: null,
    checkStatus: null,
    syncStatus: null,
  };

  const [isDrawerShow, setIsDrawerShow] = useState(false);
  const [checkInfo, setCheckInfo] = useState('');
  const [conditions, setConditions] = useState(initalState);
  const [listData, setListData] = useState({
    list: [],
    load: true,
  });
  const [outActivityList, setOutActivityList] = useState([]);
  const [resourceStateValue, setResourceStateValue] = useState('');

  const [searchForm] = Form.useForm();
  const onFinish = (values) => {
    var { outActivityId, applyId, checkStatus, syncStatus } = values;
    applyId = parseInt(applyId);
    if (values.outActivityId === '全部') outActivityId = null;
    if (values.checkStatus === '全部') checkStatus = null;
    if (values.syncStatus === '全部') syncStatus = null;
    setConditions({ ...conditions, page: 1, outActivityId, applyId, checkStatus, syncStatus });
  };

  const formRowLayout = {
    justify: 'flex-start',
    align: 'middle',
    gutter: 16,
  };

  const columns = [
    {
      align: 'center',
      title: '资源申请编号',
      dataIndex: 'id',
      width: '10%',
      render: (text, record) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ChangeHover originalApplyId={record.originalApplyId} />
            <div>{text}</div>
          </div>
        );
      },
    },
    {
      align: 'center',
      title: '资源位名称',
      dataIndex: 'resourceName',
      width: '10%',
      render: (text, record) => {
        return (
          <div>
            {record.homeFloorInfo && record.homeFloorInfo.resourceName ? record.homeFloorInfo.resourceName : '-'}
          </div>
        );
      },
    },
    {
      align: 'center',
      title: '频道名称',
      dataIndex: 'channelName',
      width: '10%',
      render: (text, record) => {
        return (
          <div>{record.homeFloorInfo && record.homeFloorInfo.channelName ? record.homeFloorInfo.channelName : '-'}</div>
        );
      },
    },
    {
      align: 'center',
      title: '频道ID',
      dataIndex: 'channelId',
      width: '10%',
      render: (text, record) => {
        return (
          <div>{record.homeFloorInfo && record.homeFloorInfo.channelId ? record.homeFloorInfo.channelId : '-'}</div>
        );
      },
    },
    {
      align: 'center',
      title: '申请时间',
      dataIndex: 'created',
      width: '10%',
    },
    {
      align: 'center',
      title: '资源申请状态',
      dataIndex: 'checkStatus',
      width: '10%',
      render: (text, record) => {
        switch (parseInt(text)) {
          case 0:
            return <Tag color="processing">&#12288;待审核&#12288;</Tag>;
          case 2:
            return <Tag color="success">&#12288;已通过&#12288;</Tag>;
          case 3:
            return (
              <div>
                <Tag color="error">&#12288;已驳回&#12288;</Tag>
                <Tooltip
                  placement="top"
                  title={'驳回原因：' + record.remark ? record.remark : '无'}
                  style={{ marginLeft: '5px' }}
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
            );
          //   case 4: return (<Tag color='processing'>修改待审核</Tag>)
        }
      },
    },
    {
      align: 'center',
      title: '同步状态',
      dataIndex: 'syncStatus',
      width: '10%',
      render: (text, record) => {
        switch (parseInt(text)) {
          case 0:
            return <div>未同步</div>;
          case 2:
            return <div>同步成功</div>;
          case 3:
            return (
              <div>
                <div>同步失败</div>
                <Tooltip placement="top" title={'失败原因：' + record.remark ? record.remark : '无'}>
                  <InfoCircleOutlined style={{ marginLeft: '5px' }} />
                </Tooltip>
              </div>
            );
          case 4:
            return (
              <div>
                <span style={{ marginRight: '5px' }}>已失效</span>
                <Tooltip placement="top" title="失效原因：修改后的申请已审核通过，原申请自动失效">
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
            );
        }
      },
    },
    {
      align: 'center',
      title: '操作',
      dataIndex: 'operation',
      width: '10%',
      render: (text, record, index) => {
        if (parseInt(record.checkStatus) === 2) {
          // 已通过
          switch (parseInt(record.syncStatus)) {
            case 0:
            case 2:
            case 3:
              return (
                <div>
                  <a
                    clstag="resource_1627030927203|8"
                    onClick={() => {
                      history.push(
                        '/material-manage/resource-square/apply?id=' +
                          record.id +
                          '&batchId=' +
                          record.applyBatchMicroVO.id
                      );
                    }}
                  >
                    修改
                  </a>
                  {record.homeFloorInfo.effectDataUrl ? (
                    <a
                      style={{ marginLeft: '10px' }}
                      href={record.homeFloorInfo.effectDataUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      效果数据
                    </a>
                  ) : null}
                </div>
              );
            // case 2:
            //   return (
            //     <div>
            //       <a
            //         clstag="resource_1627030927203|9"
            //         onClick={() => {
            //           setIsDrawerShow(true);
            //           setCheckInfo(record);
            //         }}
            //       >
            //         查看
            //       </a>
            //       {/* <a clstag='resource_1627030927203|10'>效果数据</a> */}
            //     </div>
            //   );
            // case 3:
            //   return (
            //     <a
            //       clstag="resource_1627030927203|8"
            //       onClick={() => {
            //         history.push(
            //           '/material-manage/resource-square/apply?id=' +
            //             record.id +
            //             '&batchId=' +
            //             record.applyBatchMicroVO.id
            //         );
            //       }}
            //     >
            //       修改
            //     </a>
            //   );
            case 4:
              return (
                <a
                  clstag="resource_1627030927203|9"
                  onClick={() => {
                    setIsDrawerShow(true);
                    setCheckInfo(record);
                  }}
                >
                  查看
                </a>
              );
          }
        } else if (parseInt(record.checkStatus) === 0) {
          // 待审核
          switch (parseInt(record.syncStatus)) {
            case 0:
              return (
                <a
                  clstag="resource_1627030927203|9"
                  onClick={() => {
                    setIsDrawerShow(true);
                    setCheckInfo(record);
                  }}
                >
                  查看
                </a>
              );
          }
        } else if (parseInt(record.checkStatus) === 3) {
          // 已驳回
          switch (parseInt(record.syncStatus)) {
            case 0:
              return (
                <a
                  clstag="resource_1627030927203|8"
                  onClick={() => {
                    history.push(
                      '/material-manage/resource-square/apply?id=' +
                        record.id +
                        '&batchId=' +
                        record.applyBatchMicroVO.id
                    );
                  }}
                >
                  修改
                </a>
              );
          }
        }
        // else if(parseInt(record.checkStatus)===4){//修改待审核
        //     switch(parseInt(record.syncStatus)){
        //         case 0: return(<a>查看</a>)
        //     }
        // }
      },
    },
  ];

  useEffect(() => {
    sysApis
      .getResourceState({
        // resourceStateCode: 99999,
        resourceFirstType: 1,
        pageSize: 500,
        currentPage: 1,
      })
      .then((res) => {
        const { ret } = res;
        if (ret === '0') {
          const data = res.data.resourceStates;
          var item = [];
          for (var index in data) {
            item.push({
              outActivityId: parseInt(data[index].resourceStateCode),
              outActivityName: data[index].resourceName,
            });
          }
          setOutActivityList(item);
        } else {
          // setTabinfo({ applyResources: [], load: false })
          message.error('数据请求失败');
        }
      })
      .catch((ex) => {
        // setTabinfo({ applyResources: [], load: false })
        message.error('数据请求失败');
      });
  }, []);

  useEffect(() => {
    if (getQuery('outActivityId')) {
      setResourceStateValue(parseInt(getQuery('outActivityId')));
    } else {
      setResourceStateValue('全部');
    }
  }, []);

  useEffect(() => {
    apis.yxApplyReadServicequeryForList(conditions).then((res) => {
      const {
        ret,
        data: { items, totalCount },
      } = res;
      if (ret === '0') {
        setListData({
          list: items,
          loading: false,
          totalCount: totalCount,
        });
      } else {
        setListData({
          list: [],
          loading: false,
          totalCount: [],
        });
      }
    });
  }, [conditions]);

  const outActivitySelect = (value) => {};

  return (
    // <div className='resource-list-wrap'>
    <>
      {/* <div className='resource-list-search filter-box-wrap'> */}
      <Container>
        <div style={{ paddingTop: '15px' }}>
          <Form form={searchForm} onFinish={onFinish}>
            <Row {...formRowLayout}>
              <Col span={4}>
                <Form.Item name="outActivityId" label="资源位">
                  {resourceStateValue ? (
                    <Select defaultValue={resourceStateValue} allowClear onChange={outActivitySelect}>
                      <Select.Option key="all" value="全部">
                        全部
                      </Select.Option>
                      {/* <Select.Option key='al9l' value="99999">99999</Select.Option> */}
                      {
                        outActivityList.map((outActivity) => (
                          <Select.Option key={outActivity.outActivityId} value={outActivity.outActivityId}>
                            {outActivity.outActivityName}
                          </Select.Option>
                        ))
                        // STATUS.map(item => <Option key={item.val} value={item.val}>{item.title}</Option>)
                      }
                    </Select>
                  ) : (
                    <div />
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name="applyId"
                  label="申请编号"
                  rules={[
                    {
                      required: false,
                      pattern: new RegExp(/^[1-9]\d*$/, 'g'),
                      message: '请输入正确编号',
                    },
                  ]}
                >
                  <Input maxLength={50} placeholder="请输入申请编号" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="checkStatus" label="申请状态">
                  <Select defaultValue="全部" allowClear>
                    {CHECK_STATUS.map((item) => (
                      <Select.Option key={item.val} value={item.val}>
                        {item.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="syncStatus" label="同步状态">
                  <Select defaultValue="全部" allowClear>
                    {SYNC_STATUS.map((item) => (
                      <Select.Option key={item.val} value={item.val}>
                        {item.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Row align="middle" justify="end">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      clstag="pageclick|keycount|hclist_1603695042080|1"
                      style={{ marginRight: '16px' }}
                    >
                      查询
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button onClick={() => searchForm.resetFields()} type="submit">
                      重置
                    </Button>
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>
      {/* </div> */}
      <Container>
        {/* <Container bg={false} margin={{ left: false, right: false, top: true }}> */}
        {/* <div className='resource-list-body'>
          <div className='resource-list-header'>资源申请列表</div> */}
        <BlockWrapper title="资源申请列表">
          <Table
            className="resource-list"
            columns={columns}
            dataSource={listData.list}
            rowKey={(record) => record.id}
            loading={listData.load}
            pagination={{
              pageSize: conditions.pageSize,
              current: conditions.page,
              onChange: (toPages) => setConditions((conditions) => Object.assign({}, conditions, { page: toPages })),
              total: listData.totalCount,
              showSizeChanger: false,
            }}
          />
        </BlockWrapper>
        {/* </div> */}
      </Container>
      <CheckDetail
        subTitle={null}
        footer={null}
        data={checkInfo}
        visible={isDrawerShow}
        onClose={() => setIsDrawerShow(false)}
      />
    </>
  );
}

const _ResourceList = () => {
  return (
    <ContextResourceList.Consumer>
      {(data) => {
        return <ResourceList resourceListInfo={data} />;
      }}
    </ContextResourceList.Consumer>
  );
};

export default connect((state) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
  };
})(_ResourceList);
